export const initPremiumReview = () => {
  const premiumReview = document.getElementById("premium-review") as HTMLDivElement;

  if (!premiumReview) {
    return;
  }

  const review1step3Button = premiumReview.querySelector(
    ".write-review-1 .step-3-button",
  ) as HTMLButtonElement;
  const review2BackButton = premiumReview.querySelector(
    ".write-review-2 .back-button",
  ) as HTMLButtonElement;
  const review3BackButton = premiumReview.querySelector(
    ".write-review-3 .back-button",
  ) as HTMLButtonElement;

  const candidatesForm = premiumReview.querySelector(
    ".write-review-2 form.candidates",
  ) as HTMLFormElement;

  const cancelSteps: NodeListOf<HTMLDivElement> = premiumReview.querySelectorAll(
    ".subscription-cancel-step",
  );
  const review1Step = premiumReview.querySelector(".write-review-1") as HTMLDivElement;
  const review2Step = premiumReview.querySelector(".write-review-2") as HTMLDivElement;
  const review3Step = premiumReview.querySelector(".write-review-3") as HTMLDivElement;

  const hideCancelSteps = () => {
    cancelSteps.forEach((step) => {
      step.classList.add("d-none");
    });
  };

  if (review1step3Button) {
    review1step3Button.addEventListener("click", () => {
      hideCancelSteps();
      review2Step.classList.remove("d-none"); // Shows step 2
    });
  }

  if (review2BackButton) {
    review2BackButton.addEventListener("click", () => {
      hideCancelSteps();
      review1Step.classList.remove("d-none"); // Shows step 1
    });
  }

  if (candidatesForm) {
    candidatesForm.addEventListener("submit", (e) => {
      e.preventDefault();

      const matchUserInput = candidatesForm.querySelector(
        "input[name='subscription_cancel_match_user_id']:checked",
      ) as HTMLInputElement;

      if (!matchUserInput) {
        return;
      }

      /* Check if user selected "other", so we can submit the form */
      if (matchUserInput.value === "other") {
        candidatesForm.submit();

        return;
      }

      /* Check if user already wrote a review for this user, so we can skip the review step */
      if (matchUserInput.dataset.reviewId) {
        candidatesForm.submit();

        return;
      }

      const userId = matchUserInput.value;
      const name = matchUserInput.dataset.name as string;

      const photoLabel = matchUserInput.closest("label") as HTMLLabelElement;
      const photoTag = photoLabel.querySelector(".thumb") as HTMLImageElement;
      const photo_src = photoTag.src as string;

      const subscriptionReviewCancelInput = review3Step.querySelector(
        ".form-review input[name='subscription_cancel_match_user_id']",
      ) as HTMLInputElement;

      subscriptionReviewCancelInput.value = userId;

      const subscriptionFormSkipInput = review3Step.querySelector(
        ".form-skip input[name='subscription_cancel_match_user_id']",
      ) as HTMLInputElement;
      subscriptionFormSkipInput.value = userId;

      const nameSpan = review3Step.querySelector(".name") as HTMLSpanElement;
      nameSpan.innerText = name ? name : "";

      const reviewDescriptionTextarea = review3Step.querySelector(
        "textarea",
      ) as HTMLTextAreaElement;

      let reviewDescriptionPlaceholder = reviewDescriptionTextarea.getAttribute(
        "placeholder",
      ) as string;

      reviewDescriptionPlaceholder = reviewDescriptionPlaceholder.replace("{first_name}", name);
      reviewDescriptionTextarea.setAttribute("placeholder", reviewDescriptionPlaceholder);

      const reviewThumb = review3Step.querySelector(".thumb") as HTMLDivElement;

      reviewThumb.setAttribute("alt", name);
      reviewThumb.setAttribute("src", photo_src);

      hideCancelSteps();
      review3Step.classList.remove("d-none"); // Shows step 3
    });
  }

  if (review3BackButton) {
    review3BackButton.addEventListener("click", () => {
      hideCancelSteps();
      review2Step.classList.remove("d-none"); // Shows step 2
    });
  }
};
